export const numberFilter = (onChange: (value: string) => void) => (value: string) => {
  return onChange(value.replace(/\D/g, ''));
};

export const isNonNil = <T>(value: T | null | undefined | void): value is T => value != null;
